import { useEffect } from 'react';

const StructuredData = () => {
  useEffect(() => {
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "PixelMatos",
      "url": "https://pixelmatos.com",
      "logo": "https://cdn.abacus.ai/images/38c0a685-af73-4015-b167-b5732136aca7.png",
      "description": "Desenvolvimento web, aplicativos mobile, consultoria técnica e soluções empresariais para startups e pequenas empresas",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "São Paulo",
        "addressRegion": "SP",
        "addressCountry": "BR"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+55-11-9999-9999",
        "contactType": "customer service",
        "email": "contato@pixelmatos.com",
        "availableLanguage": ["Portuguese"]
      },
      "sameAs": [
        "https://github.com/paulokmatos"
      ]
    };

    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "PixelMatos",
      "image": "https://cdn.abacus.ai/images/38c0a685-af73-4015-b167-b5732136aca7.png",
      "@id": "https://pixelmatos.com",
      "url": "https://pixelmatos.com",
      "telephone": "+55-11-9999-9999",
      "priceRange": "$$",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "São Paulo",
        "addressLocality": "São Paulo",
        "addressRegion": "SP",
        "postalCode": "01000-000",
        "addressCountry": "BR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": -23.5505,
        "longitude": -46.6333
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday"
          ],
          "opens": "09:00",
          "closes": "18:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "09:00",
          "closes": "13:00"
        }
      ]
    };

    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Software Development",
      "provider": {
        "@type": "Organization",
        "name": "PixelMatos"
      },
      "areaServed": {
        "@type": "Country",
        "name": "Brazil"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Serviços de Desenvolvimento",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Desenvolvimento Web",
              "description": "Sites e aplicações web modernas, responsivas e otimizadas"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Desenvolvimento Mobile",
              "description": "Apps nativos e híbridos para iOS e Android"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Consultoria Técnica",
              "description": "Orientação especializada para decisões tecnológicas"
            }
          }
        ]
      }
    };

    const script1 = document.createElement('script');
    script1.type = 'application/ld+json';
    script1.text = JSON.stringify(organizationSchema);
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'application/ld+json';
    script2.text = JSON.stringify(localBusinessSchema);
    document.head.appendChild(script2);

    const script3 = document.createElement('script');
    script3.type = 'application/ld+json';
    script3.text = JSON.stringify(serviceSchema);
    document.head.appendChild(script3);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
      document.head.removeChild(script3);
    };
  }, []);

  return null;
};

export default StructuredData;
